import React from "react";
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import {
    Container,
    Header,
    Image,

} from "semantic-ui-react";
import DesignerImage from '../../images/grafix-banner/gfx-link-expired.svg';
import { Link } from 'react-router-dom';

class NotFound extends React.Component {
    componentDidMount() {
        dispatch.app.baseModuleType("Account")
    }
    render() {
        return (
            <Container className="pad_40 bg-white">
                <Header as='h2' className='text-muted' icon textAlign='center' >Oops!</Header>
                <Header as='h3' className='text-muted' sub textAlign='center'>This Link does not exists</Header>
                <Image style={{ 'height': '300px' }} src={DesignerImage} className="landingImage" size='large' centered={true} />
                <Header as='h5' className='text-muted' icon textAlign='center'>The link you are looking for is either not found or has been removed.<br />
                    {this.props.match.params.accountId ? <span>
                        If you accidentaly came here, go back <Link to={`/app/${this.props.selectedAccount._id}/dashboard`}>Dashboard</Link>
                    </span> : null}
                </Header>
            </Container>
        );
    }
}
function mapStateToProps(state) {
    return {
        selectedAccount: state.app.selectedAccount,
    };
}

const connectedNotFound = connect(mapStateToProps)(NotFound);
export default connectedNotFound
